<template>
  <AppIcon icon="mdi:lightning-bolt" color="#ffac33" />
</template>